export default __webpack_public_path__ + "1515850a3002c768aaf2370f7daa5bf1.svg";